import { render } from "./PageAdd.vue?vue&type=template&id=0e12ff58"
import script from "./PageAdd.vue?vue&type=script&lang=js"
export * from "./PageAdd.vue?vue&type=script&lang=js"

import "./PageAdd.vue?vue&type=style&index=0&id=0e12ff58&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__